import React, { useEffect, useState } from "react"

/**
 * Redirect component for proxy pages (/ and /about).
 * 
 * When the client-side React app accidentally renders these paths,
 * this component redirects to the same path with ?_proxy_redirect=1 appended.
 * This triggers a full page reload, which hits the Cloud Function
 * and returns the proxied content from the external product site.
 * 
 * To prevent infinite loops:
 * - If ?_proxy_redirect=1 is already present, show a fallback message instead of redirecting
 * 
 * Note: We use "_proxy_redirect" as a specific parameter name to avoid conflicts
 * with other query parameters that might be used by the application.
 */
const PROXY_REDIRECT_PARAM = "_proxy_redirect"
const PROXY_REDIRECT_VALUE = "1"

export const ProxyRedirect = () => {
  const [shouldShowFallback, setShouldShowFallback] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const hasProxyRedirect = urlParams.get(PROXY_REDIRECT_PARAM) === PROXY_REDIRECT_VALUE

    if (hasProxyRedirect) {
      setShouldShowFallback(true)
    } else {
      const currentPath = window.location.pathname
      const newUrl = `${currentPath}?${PROXY_REDIRECT_PARAM}=${PROXY_REDIRECT_VALUE}`
      window.location.href = newUrl
    }
  }, [])

  if (!shouldShowFallback) {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6 text-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>ページを読み込んでいます...</p>
          </div>
        </div>
      </div>
    )
  }

  const currentPath = window.location.pathname
  const targetUrl = currentPath === "/" ? "/" : currentPath

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6 text-center">
          <h1 className="mb-4">POPOPO</h1>
          <p className="mb-4">
            自動で移動しない場合は、以下のリンクをクリックしてください。
          </p>
          <a href={targetUrl} className="btn btn-primary btn-lg">
            ページを開く
          </a>
        </div>
      </div>
    </div>
  )
}
